import {json, redirect} from "@remix-run/node";
import {Form, useLoaderData} from "@remix-run/react";
import {login} from "../../shopify.server";
import styles from "./styles.module.css";

export const loader = async ({request}) => {
  const url = new URL(request.url);

  if (url.searchParams.get("shop")) {
    throw redirect(`/app?${url.searchParams.toString()}`);
  }

  return json({showForm: Boolean(login)});
};

export default function App() {
  const {showForm} = useLoaderData();

  return (
    <div className={styles.index}>
      <div className={styles.content}>
        <h1 className={styles.heading}>Wally – Reviews Importer</h1>
        <p className={styles.text}>
          Import reviews from Google, Trustpilot, Facebook, and Etsy to your Shopify store and display them in a
          customizable widget.
        </p>
        {showForm && (
          <Form className={styles.form} method="post" action="/auth/login">
            <label className={styles.label}>
              <span>Shop domain</span>
              <input className={styles.input} type="text" name="shop"/>
              <span>e.g: my-shop-domain.myshopify.com</span>
            </label>
            <button className={styles.button} type="submit">
              Log in
            </button>
          </Form>
        )}
        <ul className={styles.list}>
          <li>
            <strong>Editable content</strong>. You can edit the content of reviews, approve them, and remove negative
            ones.
          </li>
          <li>
            <strong>Design widgets</strong>. Customize styles, colors, and choose which review elements to display or
            hide.
          </li>
          <li>
            <strong>Verified reviews</strong>. All reviews are already verified, no action required.
          </li>
        </ul>
      </div>
    </div>
  );
}
